module.exports = __webpack_public_path__ + "static/theworldbank_r-88e51c869901a682e790a92e7d8b962c.png";